// extracted by mini-css-extract-plugin
module.exports = {"resetBtn":"_3-K1C8g1w7NxPKrOOlio_q","icon":"_1GjKFwc0h6uwo6g-bpbdP8","active":"_3ZatDKCJ5_3rrd6l5QBoPD"};